import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef, forwardRef, useEffect } from 'react';
import PropTypes from 'prop-types';
const stickyHeaderHeight = 75;
const StepWrapper = forwardRef(({ color = 'gray', children }, ref) => {
    const loaded = useRef(false);
    const sectionClassName = color === 'gray' ? 'content-section--gray' : 'content-section--white';
    useEffect(() => {
        if ((ref === null || ref === void 0 ? void 0 : ref.current) != null && loaded.current === false) {
            loaded.current = true;
            window.scrollTo({
                top: ref.current.getBoundingClientRect().top - stickyHeaderHeight + window.scrollY,
                behavior: 'smooth'
            });
        }
    }, [ref === null || ref === void 0 ? void 0 : ref.current]);
    return (_jsx("section", Object.assign({ ref: ref, className: `${sectionClassName} py-5 md:py-10` }, { children: _jsx("div", Object.assign({ className: 'container mx-auto' }, { children: _jsx("div", Object.assign({ className: 'w-full p-4 md:p-0 md:w-8/12 mx-auto' }, { children: children })) })) })));
});
StepWrapper.displayName = 'StepWrapper';
StepWrapper.propTypes = {
    color: PropTypes.oneOf(['white', 'gray']),
    children: PropTypes.node
};
export default StepWrapper;
